const translations = {
  "en": {
    "Add a new account": "Add a new account"
  },
  "zh-tw": {
    "Add a new account": "新增帳戶"
  }
};

export default translations;
